import { Heading, Box, Flex, Table, Card } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { TableRow, TableFooterReduced, TableSearch, TableHeaders } from '.';
import { DataTableContext } from '..';
import Loading from '@/components/common/loading';
// import TableFilters from './table-filters';

const TableLoadingRow = () => (
  <Table.Body>
    <Table.Row>
      <Table.Cell>
        <Loading />
      </Table.Cell>
    </Table.Row>
  </Table.Body>
);

export const TableRoot: React.FC = () => {
  const { tableProps: props } = useContext(DataTableContext);
  const {
    displayInCard,
    header,
    tableData,
    isLoading,
    styles,
    borderStyles,
    showTableFooter = true,
    pageInfoReduced,
  } = props;

  const tableElement = (
    <>
      {/* Filters */}
      {/* <TableFilters /> */}
      {/* Table */}
      <Table.Root css={styles.container}>
        <TableHeaders />
        {!isLoading && !tableData && <>No data...</>}
        {isLoading && <TableLoadingRow />}
        {!isLoading && (
          <Table.Body>
            {tableData.map((row: { [key: string]: unknown }, index: number) => (
              <TableRow row={row} index={index} key={`tableRow${index}`} />
            ))}
          </Table.Body>
        )}
        {showTableFooter && pageInfoReduced && <TableFooterReduced />}
      </Table.Root>
    </>
  );

  return (
    <Box css={styles.container} {...(borderStyles ? { border: borderStyles } : {})} w={{ base: 'auto', lg: 'full' }}>
      {header && <Heading css={styles.header}>{header}</Heading>}
      <Flex alignItems={'center'}>
        <TableSearch />
        {/* <TableFilters /> */}
      </Flex>
      <Flex overflowY="visible" w="full">
        {displayInCard && (
          <Card.Root w={'100%'}>
            <Card.Body p={0}>{tableElement}</Card.Body>
          </Card.Root>
        )}
        {!displayInCard && tableElement}
      </Flex>
    </Box>
  );
};
